export const ru = {
    campaign: 'Кампания',
    group: 'Группа',
    'minus-phrases-per-group': 'Минус-фразы на группу',
    'not-specified': 'не заданы',
    region: 'Регион'
};
